// Module
var code = "<a ng-if=\"!match.model.id\"> {{ \"Entities.AlarmCentral.OperatorStation.CreateNew\" | translate }} </a> <a ng-if=\"match.model.id\"> <table> <tr> <td> <div ng-bind-html=\"match.model.computerName | uibTypeaheadHighlight:query\"></div> </td> </tr> </table> </a> ";
// Exports
var _module_exports = code;;
var path = '/App/Components/Forms/FindAddArcOperatorStation/FindArcOperatorStationResultTemplate.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;